import React from 'react'
import { Image } from 'semantic-ui-react'
import { useRouter } from 'next/router'

import defaultStyles from 'components/Appointments/AppointmentBookingModal/BookingApproval/styles'
import { mergeStyles } from '@enlyt/base'
import TimeLocation from 'components/Appointments/AppointmentBookingModal/TimeLocation'
import Loading from 'components/Loading'

const IconConfirmed = '/media/icons/eh-icon-confirmed.svg'

const BookingApproval = props => {
  const styles = mergeStyles(defaultStyles, props.style)
  const {
    selectedTimeslot,
    locationSelected,
    isLoadingOfCreatingAppointment,
    isErrorOfCreatingAppointment,
    isLoadingOfReschedulingAppointment,
    isErrorOfReschedulingAppointment
  } = props
  const routePathName = useRouter().pathname
  const isLoading =
    isLoadingOfCreatingAppointment || isLoadingOfReschedulingAppointment
  const isError =
    isErrorOfCreatingAppointment || isErrorOfReschedulingAppointment

  const renderContent = () => {
    if (isLoading) {
      return <Loading />
    }

    return (
      <div style={styles.container}>
        {!isError && <Image src={IconConfirmed} alt='' />}
        <div style={styles.confirmation}>
          {isError
            ? 'Something went wrong'
            : routePathName.includes('visits')
              ? 'Appointment Rescheduled'
              : 'Appointment Confirmed'}
        </div>
        <TimeLocation
          selectedTimeslot={selectedTimeslot}
          locationSelected={locationSelected}
        />
      </div>
    )
  }

  return renderContent()
}

export default BookingApproval
